/* eslint-disable dot-notation */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Typography,
} from '@material-ui/core';
import Papa from 'papaparse';

import { normalizePhoneNumber } from '../../helpers';
import ReservationTable from '../tables/ReservationTable';
import {
  createVerificationSessionsFromList,
  setReservations,
  setReservationsResults,
  selectReservations,
  selectReservationsResults,
  selectIsPending,
} from '../../store/importSlice';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
  },
  submit: {
    marginBottom: theme.spacing(2),
  },
}));

export default function ReservationImportForm({ clientId }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const reservations = useSelector(selectReservations);
  const reservationsResults = useSelector(selectReservationsResults);
  const isPending = useSelector(selectIsPending);

  const [file, setFile] = useState(null);
  const [data, setData] = useState([]);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const updateData = (result) => {
    setData(result.data || []);
  };

  const attemptImportReservations = (event) => {
    event.preventDefault();
    if (reservations.length > 0 && clientId) {
      dispatch(createVerificationSessionsFromList({ clientId, reservations }));
    }
  };

  useEffect(() => {
    if (file) {
      Papa.parse(file, {
        complete: updateData,
        header: true,
      });
    }
  }, [file]);

  useEffect(() => {
    dispatch(setReservationsResults([]));
    dispatch(setReservations(data
      .map((row, index) => ({
        id: index,
        reservationId: row['Reservation ID'] || row['reservationId'],
        arrivalDate: row['Arrival Date'] || row['arrivalDate'],
        departureDate: row['Departure Date'] || row['departureDate'],
        firstName: row['Last Name'] || row['lastName'] || row['Coverage Holder Name']?.split(' ')[0],
        lastName: row['First Name'] || row['firstName'] || row['Coverage Holder Name']?.split(' ').pop(),
        email: row['Email'] || row['email'] || row['Coverage Holder Email Address'],
        phoneNumber: normalizePhoneNumber(
          row['Phone Number'] || row['phoneNumber'] || row['Coverage Holder Phone Number'],
        ),
        street: row['Street'] || row['street'] || row['Coverage Holder Address'],
        city: row['City'] || row['city'] || row['Coverage Holder City'],
        state: row['State'] || row['state'] || row['Coverage Holder State'],
        postalCode: row['Postal Code'] || row['postalCode'] || row['Coverage Holder Postal Code'],
        country: row['country'] || row['Country'] || row['Coverage Holder Country'],
      }))
      .filter((row) => row.reservationId)));
  }, [dispatch, data]);

  return (
    <>
      <form className={classes.form} noValidate>
        <input
          className="csv-input"
          type="file"
          name="file"
          placeholder={null}
          onChange={handleFileChange}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={attemptImportReservations}
          disabled={reservations.length === 0 || isPending || !clientId}
        >
          Import Reservations
        </Button>
      </form>
      <Typography align="left" component="h3" variant="h5">
        {reservationsResults.length > 0 ? 'Import Results' : 'Import Preview'}
      </Typography>
      <ReservationTable
        rows={reservations.length > 0 && reservationsResults.length > 0 ? reservationsResults : reservations}
        result={reservations.length > 0 && reservationsResults.length > 0}
      />
    </>
  );
}
